import { BgImg } from "../assests";

const About = () => {
  return (
    <div>
      <div className="px-16 pt-8 text-center text-3xl">About Us</div>
      <div className="px-24 py-32">
        <div
          className="border-2 p-16 text-justify text-xl"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center"
          }}>
          THE FASHION STORE caters to thoughtful shoppers who appreciate unique designs and top
          quality pieces you just can’t find anywhere else. We are constantly curating fresh new
          collections and looking for the next big thing our customers will love. Founded in Vienna
          in 2019, we are proud to be your Online Clothing Shop that you can rely on for our expert
          service and care. Our Mission is to make a difference through our branding by staying
          ahead of the fashion trends, defining style and giving customers what they want.Our Vision
          is to change the way our society connects with the fashion industry by providing our
          customers with products that are ethically and responsibly sourced.
        </div>
      </div>
    </div>
  );
};

export default About;
